import CartProductCard from './CartProductCard';

export default CartProductCard;
